import {ThemeColors} from '../themeColors';

/**
 * @deprecated Use `(useTheme|theme).palette` from `@mui/material` instead.
 */
export const useThemeColors = () => ThemeColors;
